<template>
  <ContextMenu v-if="comment_options.length" :options="comment_options" />
</template>

<script>
import { computed } from "vue";
import ContextMenu from "../ui/ContextMenu.vue";
import { useCommentsStoreRefactor } from "@/stores/commentsStoreRefactor";

export default {
  name: "CommentOptions",
  components: {
    ContextMenu,
  },
  props: ["comment"],
  setup(props, { emit }) {
    const commentsStore = useCommentsStoreRefactor();

    const handleDelete = async (comment) => {
      try {
        await commentsStore.destroy(comment);
        emit("comment_deleted", comment);
      } catch (error) {
        console.error("Error deleting comment:", error);
      }
    };

    const comment_options = computed(() => {
      let options = [];
      if (props.comment.can_edit) {
        options.push({
          name: "Feedback wijzigen",
          action: () => emit("edit_comment", props.comment),
          icon: "mdi-playlist-edit",
        });
      }

      if (props.comment.can_destroy) {
        options.push({
          name: "Feedback verwijderen",
          action: () => handleDelete(props.comment),
          icon: "mdi-delete",
        });
      }
      return options;
    });

    return {
      comment_options,
    };
  },
};
</script>
